import { render, staticRenderFns } from "./HistoryChart.vue?vue&type=template&id=565c2f6c&"
import script from "./HistoryChart.vue?vue&type=script&lang=js&"
export * from "./HistoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports